// import Cookies from 'js-cookie'
export function setCookie(name, value, expireHours?) {
  let cookieString = name + '=' + encodeURI(value)
  const domain = location.hostname.split('.').slice(-2).join('.')
  if (expireHours) {
    let date = new Date()
    date.setTime(date.getTime() + expireHours * 3600 * 1000)
    if (import.meta.env.VITE_ENV !== 'local') {
      cookieString =
        cookieString +
        ';path=/; domain=.' +
        domain +
        ';expires=' +
        date.toString()
    } else {
      cookieString =
        cookieString + ';path=/; domain=localhost;expires=' + date.toString()
    }
  } else {
    if (import.meta.env.VITE_ENV !== 'local') {
      cookieString = cookieString + ';path=/; domain=.' + domain + ';'
    } else {
      cookieString = cookieString + ';path=/; domain=localhost;'
    }
  }
  document.cookie = cookieString
}

export function setDotCookie(name, value, expireHours?) {
  let cookieString = name + '=' + encodeURI(value)
  let host = location.hostname
  if (expireHours) {
    let date = new Date()
    date.setTime(date.getTime() + expireHours * 3600 * 1000)
    if (import.meta.env.VITE_ENV !== 'local') {
      cookieString =
        cookieString +
        ';path=/; domain=.' +
        host +
        ';expires=' +
        date.toString()
    } else {
      cookieString =
        cookieString + ';path=/; domain=localhost;expires=' + date.toString()
    }
  } else {
    if (import.meta.env.VITE_ENV !== 'local') {
      cookieString = cookieString + ';path=/; domain=.' + host + ';'
    } else {
      cookieString = cookieString + ';path=/; domain=localhost;'
    }
  }
  document.cookie = cookieString
}
export function setRawDomainCookie(name, value, expireHours) {
  let cookieString = name + '=' + encodeURI(value)
  let host = document.domain
  if (expireHours) {
    let date = new Date()
    date.setTime(date.getTime() + expireHours * 3600 * 1000)
    if (import.meta.env.VITE_ENV !== 'local') {
      cookieString =
        cookieString +
        ';path=/; domain=.' +
        host +
        '; expires=' +
        date.toString()
    } else {
      cookieString =
        cookieString + ';path=/; domain=localhost;expires=' + date.toString()
    }
  } else {
    if (import.meta.env.VITE_ENV !== 'local') {
      cookieString = cookieString + ';path=/;'
    } else {
      cookieString = cookieString + ';path=/; domain=.' + host + ';'
    }
  }
  document.cookie = cookieString
}

export function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2])
  } else {
    return null
  }
}

export function ClearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
  if (keys) {
    for (var i = keys.length; i--; ) {
      //授权码登录用的token不失效
      if (keys[i] === 'TS-TOKEN'){
        continue;
      }
      document.cookie =
        keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() //清除当前域名下的
      document.cookie =
        keys[i] +
        '=0;path=/;domain=' +
        document.domain +
        ';expires=' +
        new Date(0).toUTCString() //清除当前域名下的
      document.cookie =
        keys[i] +
        '=0;path=/;domain=kevis.com;expires=' +
        new Date(0).toUTCString() //清除一级域名下的或指定的
    }
  }
}
